module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/arrow-navigation-b118b3b83b877f6f92642d5d351b5107.svg";